import React from 'react';
import { get, size } from 'global/lib/lodash';
import { ScorecardToggleGroup } from './ScorecardToggle.styles';
import { Button } from '@mui/material';
import ScoreIcon from 'global/components/ScoreIcon';

export default (props) => {
  const { processedOverallScores, scorecards, setScorecardIndex, scorecardIndex, activeEdit } = props;

  const show = size(processedOverallScores) > 1;

  return !show ? null : (
    <ScorecardToggleGroup value={scorecardIndex} variant="contained" disableElevation size="small">
      {scorecards.map((di, i) => {
        const selected = scorecardIndex === i;
        const score = get(processedOverallScores, `${i}.value`);
        return (
          <Button
            disableElevation
            color={selected ? 'primary' : 'inherit'}
            variant={selected ? 'contained' : 'outlined'}
            startIcon={score && <ScoreIcon score={score} />}
            // disable scorecard toggling if Edit mode is enabled
            disabled={!selected && typeof activeEdit === 'object'}
            onClick={() => setScorecardIndex(i)}
          >
            {get(di, 'name', `Scorecard ${i + 1}`)}
          </Button>
        );
      })}
    </ScorecardToggleGroup>
  );
};
